import React from 'react';
import { Grid, Divider, Image, Button } from 'semantic-ui-react';
import { renderDataAsHtml, renderDataAsPlainText } from '../../api/renderPrismicData';
import withFullScreenLoading from '../UtilityComponents/withFullScreenLoading';
import withDataFetch from '../../api/withDataFetch';
import './Education.css';
import LinkButton from '../UtilityComponents/LinkButton/index';

const Education = ({
  data: {
    paragraph0,
    paragraph0_1: paragraph01,
    paragraph1,
    paragraph2,
    paragraph3,
    subtitle,
    subtitle1,
    subtitle2,
    title,
    image: { url: image },
    folder_pdf: folderPdf,
    registration_pdf: registrationPdf,
  },
}) => {
  return (
    <Grid stackable className="Education">
      <Grid.Row centered columns="equal">
        <h2 className="Page__Title">
          {renderDataAsPlainText(title)}
        </h2>
      </Grid.Row>
      <Divider />
      <Grid.Row columns="two">
        <Grid.Column width={10}>
          {renderDataAsHtml(paragraph0)}
          <a href={folderPdf.url} download className="Education__Download" target="_blank" rel="noopener noreferrer">
            <Button className="btn-animated">
              Download de folder over onderwijs
            </Button>
          </a>
          <a href={registrationPdf.url} download className="Education__Download" target="_blank" rel="noopener noreferrer">
            <Button className="btn-animated">
              Download het aanmeldingsformulier onderwijs
            </Button>
          </a>
        </Grid.Column>
        <Grid.Column width={6}>
          <Image fluid rounded src={image} />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          {renderDataAsHtml(paragraph01)}
        </Grid.Column>
      </Grid.Row>
      <Divider />

      <Grid.Row>
        <Grid.Column>
          <h3>{renderDataAsHtml(subtitle)}</h3>
          {renderDataAsHtml(paragraph1)}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <h3> {renderDataAsHtml(subtitle1)}</h3>
          {renderDataAsHtml(paragraph2)}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <h3> {renderDataAsHtml(subtitle2)}</h3>
          {renderDataAsHtml(paragraph3)}
          <LinkButton link="/contact" text="Contact" />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default withDataFetch(withFullScreenLoading(Education), 'opleiding');



// WEBPACK FOOTER //
// ./src/components/Education/index.js